import { LogModel } from './../../models/log.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LogService } from '../../services/log.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
  selector: 'app-main-details',
  templateUrl: './main-details.component.html',
  styleUrls: ['./main-details.component.css']
})
export class MainDetailsComponent implements OnInit, OnDestroy {

  logModels: LogModel[];
  sid: string;
  pages: string[];
  sessionStartDate = '';
  filterSelection = 'all';
  displayedColumns: string[] = ['timestamp', 'page', 'eventType', 'stepDescription', 'context', 'help'];
  constructor(private route: ActivatedRoute,
              private logService: LogService,
              private router: Router) { }
  
  ngOnDestroy(): void {
    this.pages = null;
  }

  ngOnInit(): void {
    this.pages = [];
    this.route.paramMap.subscribe(map => {
      this.sid = map.get('sid');
      this.logService.getLogs(this.sid)
      .subscribe(logs => {
        this.logModels = logs;
        this.computePages();
        this.populateSessionStartDate();
      }, err => {
        console.log(err.message);
        this.pages = [];
      });
    });
  }


  private computePages(): void{
    this.pages = [];
    for (const log of this.logModels){
      if (!this.pages.find(x => x === log.pageId)){
        this.pages.push(log.pageId);
      }
    }
  }

  public goBack(): void{
    this.router.navigate([`/main/${this.logModels[0].sin}`]);
  }

  private populateSessionStartDate(): void{
    const dt = new Date(this.logModels[0].timestamp);
    this.sessionStartDate = `${(dt.getMonth() + 1).toString().padStart(2, '0')}/${dt.getDate().toString().padStart(2, '0')}/${dt.getFullYear().toString().padStart(4, '0')} ${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}`;
  }

  public getDuration(timestamp: number): string {
    const referenceTime = this.logModels[0].timestamp;
    const difference = timestamp - referenceTime;
    const seconds = difference / 1000;
    if (seconds === 0){
      return '0';
    }
    if (seconds > 0 && seconds <= 59) {
      return `${seconds}s`;
    }
    const minDuration = Math.floor(seconds / 60);
    const remainingSeconds = seconds - (minDuration * 60);
    return `${minDuration}m ${remainingSeconds}s`;
  }

  public onFilterChange(event: MatButtonToggleChange): void{
    
  }
}
